import classNames from "classnames";
import { DComponent } from "../DComponent";
export default class FastCheckoutBtn extends DComponent {
  constructor({
    parent,
    id,
    price,
    title,
    logo,
    closeIcon,
    dragIcon,
    language,
    onCheckout = () => { },
    onClose = () => { },
  } = {}) {
    super(arguments[0], parent, id, {
      class: classNames("FastCheckoutBtn"),
      price: price,
      title: title,
      logo: logo,
      closeIcon: closeIcon,
      dragIcon: dragIcon,
      language: language,
    }, true, true);
    this.price = price;
    this.onCheckout = onCheckout;
    this.onClose = onClose;
    this.render();
  }

  static init({
    parent,
    id,
    price,
    title,
    logo,
    closeIcon,
    dragIcon,
    language,
    onCheckout = () => { },
    onClose = () => { },
  } = {}
  ) {
    return new FastCheckoutBtn({
      parent,
      id,
      price,
      title,
      logo,
      closeIcon,
      dragIcon,
      language,
      onCheckout,
      onClose,
    });
  }

  loadStyle() {
    const style = document.createElement("style");
    style.textContent = require("!!css-loader!resolve-url-loader!sass-loader!./style.scss").toString();
    this.parent.append(style);
  }

  loadHtml() {
    return require("html-loader!./index.html");
  }

  after() {
    $(".dc-close-icon", this.element).on("click", () => {
      typeof this.onClose === "function" && this.onClose();
    });
    $(".dc-fc-button", this.element).on("click", () => {
      typeof this.onCheckout === "function" && this.onCheckout();
    });
  }

  setPrice(price) {
    $(".dc-fc-price", this.element).html(price);
  }

  setLanguage(language) {
    this.element.attr("lang", language);
  }

  setTitle(title) {
    $(".dc-fc-title", this.element).html(title);
  }

  hide() {
    this.element.removeClass("show-fc");
  }

  show() {
    this.element.addClass("show-fc");
    this.animation();
  }

  animation() {
    $(".dc-fc-icon", this.element).removeClass("dc-shake");
    setTimeout(() => {
      $(".dc-fc-icon", this.element).addClass("dc-shake");
    }, 50);
  }

  disable() {
    this.element.addClass("disable");
  }

  enable() {
    this.element.removeClass("disable");
  }
}
